<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">
        <v-icon color="primary" class="mr-2">fingerprint</v-icon>
        Configurar Passkey
      </v-card-title>

      <v-card-text>
        <v-alert v-if="error" type="error" dense class="mb-3">
          {{ errorMessage }}
        </v-alert>

        <v-alert v-if="success" type="success" dense class="mb-3">
          Passkey registrada com sucesso! Você já pode fazer login usando biometria.
        </v-alert>

        <div v-if="!success">
          <p class="mb-2">
            <strong>Passkey</strong> permite login seguro usando biometria (impressão digital, reconhecimento facial)
            ou chave de segurança do seu dispositivo.
          </p>
          <p class="mb-2">
            <v-icon small class="mr-1">check_circle</v-icon> Login mais rápido e seguro
          </p>
          <p class="mb-2">
            <v-icon small class="mr-1">check_circle</v-icon> Sem necessidade de códigos PIN
          </p>
          <p class="mb-0">
            <v-icon small class="mr-1">check_circle</v-icon> Proteção contra phishing
          </p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" :disabled="loading">
          {{ success ? 'Fechar' : 'Agora não' }}
        </v-btn>
        <v-btn v-if="!success" color="primary" depressed @click="register" :loading="loading" x-large>
          Configurar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { startRegistration } from '@simplewebauthn/browser'

import PasskeyHelper from '@/helpers/passkey'

export default {
  name: 'PasskeySetup',
  mixins: [
    PasskeyHelper
  ],
  data: () => ({
    dialog: false,
    loading: false,
    error: false,
    errorMessage: '',
    success: false
  }),
  methods: {
    open () {
      this.dialog = true
      this.error = false
      this.success = false
      this.errorMessage = ''
    },
    close () {
      this.dialog = false
      // O segundo argumento distingue uma recusa de uma falha: quem chama precisa
      // saber se não convidar de novo neste aparelho ou se a tentativa deu errado.
      this.$emit('close', this.success, this.error)
    },
    async register () {
      this.loading = true
      this.error = false
      this.errorMessage = ''

      try {
        const api = process.env.VUE_APP_API
        const user = this.$localStorage.get('user')

        // 1. Obter options do servidor
        const optionsRes = await axios.post(
          `${api}/passkey/register-options`,
          {},
          { headers: { Authorization: `Bearer ${user.token}` } }
        )

        // 2. Iniciar registro (navegador exibe prompt de biometria)
        // Na v13+, usar { optionsJSON: opts } conforme documentação oficial
        const attResp = await startRegistration({ optionsJSON: optionsRes.data })

        // 3. Enviar credencial para servidor verificar
        await axios.post(
          `${api}/passkey/register-verify`,
          attResp,
          { headers: { Authorization: `Bearer ${user.token}` } }
        )

        // Este aparelho passa a ter credencial: guardamos o identificador para
        // não convidar de novo enquanto ela existir na conta.
        this.passkeyRemember(attResp.id)

        this.success = true
        // Fecha imediatamente e emite evento de sucesso
        this.close()
      } catch (err) {
        console.error('Passkey registration error:', err)

        if (err.name === 'NotAllowedError') {
          this.errorMessage = 'Operação cancelada ou não autorizada pelo navegador.'
        } else if (err.name === 'NotSupportedError') {
          this.errorMessage = 'Seu navegador ou dispositivo não suporta Passkeys.'
        } else if (err.name === 'InvalidStateError') {
          this.errorMessage = 'Este dispositivo já tem uma biometria cadastrada para a sua conta.'
        } else if (err.response?.data?.code === 'VERIFICATION_FAILED') {
          this.errorMessage = 'Falha na verificação. Tente novamente.'
        } else {
          this.errorMessage = err.response?.data?.code || 'Erro ao registrar Passkey. Tente novamente.'
        }

        this.error = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
